import { useEffect, useState, } from "react";
import { useProductMaster } from "../Hooks/useProductMaster";
import { MdAdd,} from "react-icons/md";
import { Trash2 } from "lucide-react";
import { Spinner, GenericTable, Pagination, SearchableDropdown, } from "../../../Components/Common";
import { PRODUCT_META_TABS, CATEGORY_COLUMNS, CATEGORY_COLUMN_LABELS, UOM_COLUMNS, UOM_COLUMN_LABELS, ATTRIBUTE_COLUMNS, ATTRIBUTE_COLUMN_LABELS, } from "../constants";

const ProductMetaList = () => {
    const [activeTab, setActiveTab] = useState(PRODUCT_META_TABS.CATEGORY);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({});
    const {
        loading,
        setPage,
        totalPages,
        page,
        rowsPerPage,
        setRowsPerPage,
        fetchCategories,
        fetchAttributes,
        getUOMs,
        deleteCategory,
        deleteUOM,
        addCategory,
        addUOM,
        addAttribute,
        deleteAttribute,
    } = useProductMaster();

    const [categories, setCategories] = useState([]);
    const [uoms, setUOMs] = useState([]);
    const [attributes, setAttributes] = useState([]);

    const fetchCategory = async () => {
        const data = await fetchCategories();
        if (data) setCategories(data);
    };

    const fetchUOM = async () => {
        const data = await getUOMs();
        if (data) setUOMs(data);
    };

    const fetchAttribute = async () => {
        const data = await fetchAttributes();
        if (data) setAttributes(data);
    };

    const handleDeleteCategory = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this category?");
        if (!confirmDelete) return;
        await deleteCategory(id);
        await fetchCategory();
    };

    const handleDeleteUOM = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this uom?");
        if (!confirmDelete) return;
        await deleteUOM(id);
        await fetchUOM();
    };

    const handleDeleteAttribute = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this attribute?");
        if (!confirmDelete) return;
        await deleteAttribute(id);
        await fetchAttribute();
    };
    const handleAdd = () => {
        setFormData({});
        setShowModal(true);
    };


    const renderField = (key, row) => {
        switch (key) {
            case "category_name": return <span>{row.name || "-"}</span>;
            case "parent_category": return <span>{row.parent_category_name || "no parent category"}</span>;
            case "category_actions":
                return (
                <div >
                        <Trash2
                            onClick={() => handleDeleteCategory(row.id)}
                        size={20}
                        className="text-red-600 cursor-pointer"
                    />
                </div>
                );
            case "uom_name": return <span>{row.name || "-"}</span>;
            case "uom_actions":
                return (
                    <div>
                        <Trash2
                            onClick={() => handleDeleteUOM(row.id)}
                            size={20}
                            className="text-red-600 cursor-pointer"
                        />
                    </div>
                );
            case "attribute_name": return <span>{row.name || "-"}</span>;
            case "attribute_value": return <span>{row.value || "-"}</span>;
            case "attribute_actions":
                return (
                    <div>
                        <Trash2
                            onClick={() => handleDeleteAttribute(row.id)}
                            size={20}
                            className="text-red-600 cursor-pointer"
                        />
                    </div>
                );
            default:
                return row[key] ?? "-";
        }
    };
    
    useEffect(() => {
    if (activeTab === PRODUCT_META_TABS.CATEGORY) fetchCategory();
    if (activeTab === PRODUCT_META_TABS.UOM) fetchUOM();
    if (activeTab === PRODUCT_META_TABS.ATTRIBUTE) fetchAttribute();
  }, [page, rowsPerPage, activeTab,]);
    
  return (
    <div className="flex flex-col">
      {/* Header */}
      <div className="px-4 py-4">
        <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
                <h2 className="text-xl text-primary font-semibold">
                    Product Meta Master
                </h2>
            </div>
            <button
                onClick={handleAdd}
                className="bg-primary text-white px-3 py-2 rounded-md flex items-center gap-2"
            >
                <MdAdd size={18} />
                <span className="whitespace-nowrap">
                    {activeTab === PRODUCT_META_TABS.CATEGORY
                        ? "Add Category"
                        : activeTab === PRODUCT_META_TABS.UOM
                            ? "Add UOM"
                            : "Add Attribute"}
                </span>
            </button>
        </div>
        {/* Tabs */}
        <div className="flex gap-4 border-b border-gray-200">
          {Object.values(PRODUCT_META_TABS).map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 font-medium ${
                activeTab === tab
                  ? "border-b-2 border-primary text-primary"
                  : "text-gray-500"
              }`}
            >
              {tab === PRODUCT_META_TABS.CATEGORY
                ? "Category"
                : tab === PRODUCT_META_TABS.UOM
                ? "UOM"
                : "Attribute"}
            </button>
          ))}
        </div>
      </div>
          
      {/* CATEGORY TAB */}
      {activeTab === PRODUCT_META_TABS.CATEGORY && (
        <div>
          <div>
            {loading ? (
              <div className="flex items-center justify-center h-[60vh]">
                <Spinner />
              </div>
            ) : (
              <div className="w-full flex flex-col h-[61vh] md:h-[65vh] overflow-x-auto px-1">
                <GenericTable
                    tableColumns={CATEGORY_COLUMNS}
                    tableRows={categories}
                    columnLabels={CATEGORY_COLUMN_LABELS}
                    renderField={renderField}
                    enableMobileCardView={false}
                />
              </div>
            )}
          </div>
          <div>
            <div className="flex justify-end pb-4 px-4 mt-2">
                <Pagination
                    page={page}
                    totalPages={totalPages}
                    rowsPerPage={rowsPerPage}
                    onPageChange={setPage}
                    onPageSizeChange={setRowsPerPage}
                />
            </div>
          </div>
        </div>  
      )}

      {activeTab === PRODUCT_META_TABS.UOM && (
              <div>
                  <div>
                      {loading ? (
                          <div className="flex items-center justify-center h-[60vh]">
                              <Spinner />
                          </div>
                      ) : (
                          <div className="w-full flex flex-col h-[61vh] md:h-[65vh] overflow-x-auto px-1">
                              <GenericTable
                                  tableColumns={UOM_COLUMNS}
                                  tableRows={uoms}
                                  columnLabels={UOM_COLUMN_LABELS}
                                  renderField={renderField}
                                  enableMobileCardView={false}
                              />
                          </div>
                      )}
                  </div>
                  <div>
                      <div className="flex justify-end pb-4 px-4 mt-2">
                          <Pagination
                              page={page}
                              totalPages={totalPages}
                              rowsPerPage={rowsPerPage}
                              onPageChange={setPage}
                              onPageSizeChange={setRowsPerPage}
                          />
                      </div>
                  </div>
              </div>  
      )}
      {activeTab === PRODUCT_META_TABS.ATTRIBUTE && (
              <div>
                  <div>
                      {loading ? (
                          <div className="flex items-center justify-center h-[60vh]">
                              <Spinner />
                          </div>
                      ) : (
                          <div className="w-full flex flex-col h-[61vh] md:h-[65vh] overflow-x-auto px-1">
                              <GenericTable
                                  tableColumns={ATTRIBUTE_COLUMNS}
                                  tableRows={attributes}
                                  columnLabels={ATTRIBUTE_COLUMN_LABELS}
                                  renderField={renderField}
                                  enableMobileCardView={false}
                              />
                          </div>
                      )}
                  </div>
                  <div>
                      <div className="flex justify-end pb-4 px-4 mt-2">
                          <Pagination
                              page={page}
                              totalPages={totalPages}
                              rowsPerPage={rowsPerPage}
                              onPageChange={setPage}
                              onPageSizeChange={setRowsPerPage}
                          />
                      </div>
                  </div>
              </div> 
          )}
          {showModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-xl shadow-xl w-[90%] md:w-[500px] p-6">
                      <h2 className="text-lg font-semibold mb-4">
                          {activeTab === PRODUCT_META_TABS.CATEGORY
                              ? "Add Category"
                              : activeTab === PRODUCT_META_TABS.UOM
                                  ? "Add UOM"
                                  : "Add Attribute"}
                      </h2>

                      {/* Category Form */}
                      {activeTab === PRODUCT_META_TABS.CATEGORY && (
                          <>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Category Name <span className="text-red-500">*</span>
                              </label>
                              <input
                                  type="text"
                                  value={formData.name || ""}
                                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                  className="w-full border rounded-md px-3 py-2 mb-3 focus:ring-1 focus:ring-primary"
                                  placeholder="Enter Category Name"
                              />

                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Parent Category
                              </label>
                              <SearchableDropdown
                                  fetchFunction={fetchCategories}
                                  onSelect={(id) => setFormData({ ...formData, parent_category: id })}
                                  valueKey="id"
                                  labelKey="name"
                                  placeholder="Select Parent Category"
                                  includeAllOption={true}
                                  allOptionLabel="No Parent"
                              />
                          </>
                      )}

                      {/* UOM Form */}
                      {activeTab === PRODUCT_META_TABS.UOM && (
                          <>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                  UOM Name <span className="text-red-500">*</span>
                              </label>
                              <input
                                  type="text"
                                  value={formData.name || ""}
                                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                  className="w-full border rounded-md px-3 py-2 mb-3 focus:ring-1 focus:ring-primary"
                                  placeholder="Enter UOM Name"
                              />
                          </>
                      )}

                      {/* Attribute Form */}
                      {activeTab === PRODUCT_META_TABS.ATTRIBUTE && (
                          <>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Attribute Name<span className="text-red-500">*</span>
                              </label>
                              <input
                                  type="text"
                                  value={formData.name || ""}
                                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                  className="w-full border rounded-md px-3 py-2 mb-3 focus:ring-1 focus:ring-primary"
                                  placeholder="Enter Attribute Name"
                              />

                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Attribute Value<span className="text-red-500">*</span>
                              </label>
                              <input
                                  type="text"
                                  value={formData.value || ""}
                                  onChange={(e) => setFormData({ ...formData, value: e.target.value })}
                                  className="w-full border rounded-md px-3 py-2 mb-3 focus:ring-1 focus:ring-primary"
                                  placeholder="Enter Attribute Value"
                              />
                          </>
                      )}

                      {/* Buttons */}
                      <div className="flex justify-end gap-3 mt-6">
                          <button
                              onClick={() => setShowModal(false)}
                              className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300"
                          >
                              Cancel
                          </button>
                          <button
                              onClick={async () => {
                                  if (activeTab === PRODUCT_META_TABS.CATEGORY) {
                                      await addCategory(formData);
                                      await fetchCategory();
                                  } else if (activeTab === PRODUCT_META_TABS.UOM) {
                                      await addUOM(formData);
                                      await fetchUOM();
                                  } else {
                                      await addAttribute(formData);
                                      await fetchAttribute();
                                  }
                                  setShowModal(false);
                              }}
                              className="px-4 py-2 rounded-md bg-primary text-white hover:bg-secondary"
                          >
                              Save
                          </button>
                      </div>
                  </div>
              </div>
          )}

    </div>
  );
};

export default ProductMetaList;
